import React from "react";

import styles from "./login.module.scss";

export type PolicyProps = {
	toTerms: string;
	toPrivacy: string;
};

const Policy: React.FC<PolicyProps> = ({
	toTerms = "#?",
	toPrivacy = "#?",
}) => {
	return (
		<div className={`${styles.policyText} text-center`}>
			<div>By proceeding you also agree </div>
			<div>
				to the{" "}
				<a
					className={styles.link}
					href={toTerms}
					target="_blank"
					rel="no noreferrer"
				>
					Terms of Service
				</a>{" "}
				and{" "}
				<a
					className={styles.link}
					href={toPrivacy}
					target="_blank"
					rel="no noreferrer"
				>
					Privacy Policy
				</a>
			</div>
		</div>
	);
};

export default Policy;
